var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", {
      directives: [
        {
          name: "t",
          rawName: "v-t",
          value: "ADJUST_CALL_PAYMENT",
          expression: "'ADJUST_CALL_PAYMENT'"
        }
      ],
      staticClass: "ag-grid__overlay-form-box-title"
    }),
    _vm._v(" "),
    _c("div", { staticClass: "p-15" }, [
      _c(
        "div",
        {
          staticClass: "clickable m-b-10",
          on: { click: _vm.returnToReviewDetails }
        },
        [
          _c("i", { staticClass: "fa fa-chevron-left m-r-5" }),
          _vm._v("\n      " + _vm._s(_vm.returnToReviewLabel) + "\n    ")
        ]
      ),
      _vm._v(" "),
      _c("div", [
        _c("div", [
          _c("div", {
            directives: [
              {
                name: "t",
                rawName: "v-t",
                value: "CONFIRM_CHANGES",
                expression: "'CONFIRM_CHANGES'"
              }
            ],
            staticClass: "f-s-16 p-l-15 col-sm-offset-3"
          }),
          _vm._v(" "),
          _c(
            "form",
            {
              staticClass: "form-horizontal p-t-10 p-b-10",
              attrs: { name: "callActionConfirmation", role: "form" }
            },
            [
              _vm._t("default"),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _c("div", { staticClass: "p-l-15 col-sm-offset-3" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-primary btn-sm m-t-15",
                      attrs: {
                        type: "button",
                        disabled: _vm.pendingBulkCallAdjustmentByLogs
                      },
                      on: {
                        "~click": function($event) {
                          return _vm.confirmForm.apply(null, arguments)
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.$t("CONFIRM")) +
                          "\n                "
                      ),
                      _vm.pendingBulkCallAdjustmentByLogs
                        ? _c("Loader", { attrs: { "custom-class": "size-sm" } })
                        : _vm._e()
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("button", {
                    directives: [
                      {
                        name: "t",
                        rawName: "v-t",
                        value: "CANCEL",
                        expression: "'CANCEL'"
                      }
                    ],
                    staticClass: "btn btn-danger btn-sm m-t-15 m-l-10",
                    on: { click: _vm.cancelForm }
                  })
                ])
              ])
            ],
            2
          )
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }